export default "__VITE_ASSET__nXNx4Ktz__"